module.exports = "./img/9498efd98fda4f4205709aa3351f3f44.jpg";